<template>
  <b-form>
    <!-- Name -->
    <b-form-group id="nameGroup" label="Nombre" label-for="name">
      <b-form-input
        id="name"
        name="name"
        type="text"
        v-model.trim="employee.name"
        v-validate="'required|min:2'"
        placeholder="Nombre Empleado"/>
      <span class="text-danger">{{ errors.first('name') }}</span>
    </b-form-group>

    <!-- Surname -->
    <b-form-group id="surnameGroup" label="Apellidos" label-for="surname">
      <b-form-input
        id="surname"
        name="surname"
        type="text"
        v-model.trim="employee.surname"
        v-validate="'min:2'"
        placeholder="Apellidos"/>
      <span class="text-danger">{{ errors.first('surname') }}</span>
    </b-form-group>

    <!-- Phone -->
    <b-form-group id="phoneGroup" label="Teléfono" label-for="phone">
      <b-form-input
        id="phone"
        name="phone"
        type="text"
        v-model.trim="employee.phone"
        v-validate="'min:2'"
        placeholder="Teléfono"/>
      <span class="text-danger">{{ errors.first('phone') }}</span>
    </b-form-group>

    <!-- Edit mode only -->
    <template v-if="!isNewEmployee">
      <!-- Activo / Inactivo -->
      <b-form-group label="Estado empleado:">
        <b-form-radio v-model="employee.isActive" name="product-status" :value="true">Activo</b-form-radio>
        <b-form-radio v-model="employee.isActive" name="product-status" :value="false">Inactivo</b-form-radio>
      </b-form-group>
    </template>

    <br>

    <b-button v-if="isNewEmployee" @click="validateForm" variant="primary">
      Crear Empleado
      <b-spinner v-if="isEmployeeBtnLoading" small type="grow"></b-spinner>
    </b-button>
    <b-button v-else @click="validateForm" variant="primary">
      Actualizar Empleado
      <b-spinner v-if="isEmployeeBtnLoading" small type="grow"></b-spinner>
    </b-button>
  </b-form>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EmployeeForm',
  props: {
    employee: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'isEmployeeBtnLoading'
    ]),
    isNewEmployee () {
      return this.$route.name === 'EmployeeNew'
    }
  },
  methods: {
    onCreate () {
      const data = {
        ...this.employee,
        isActive: true
      }
      this.$emit('onCreate', data)
    },
    onUpdate () {
      this.$emit('onUpdate', this.employee)
    },
    validateForm () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.isNewEmployee ? this.onCreate() : this.onUpdate()
          }
        })
    }
  }

}
</script>
